import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ResponseMessageType } from "~/domains";

type RequestDataType = {
  directMessageRoomId: string;
};

const request = ({ directMessageRoomId }: RequestDataType) => {
  return new ApiClient()
    .put<ResponseMessageType>(
      `/api/members/direct_message_rooms/${directMessageRoomId}/reads`,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisMembersDirectMessageRoomsReadsUpdate = ({
  options = {},
}: PropsType = {}): UseMutationResult<ResponseMessageType, RequestDataType> => {
  return useMutation(request, { ...options });
};
